export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-bluetooth-94b0ce94e13b4e2952e5395f9007aefc.svg";